import type { AnimationEvent } from '@angular/animations';
import { CdkDialogContainer, DialogModule } from '@angular/cdk/dialog';
import { PortalModule } from '@angular/cdk/portal';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
} from '@angular/core';
import { dialogOpenAndLeave } from './dialog-animated-container.animation';

@Component({
  selector: 'palantir-dialog-animated-container',
  templateUrl: './dialog-animated-container.component.html',
  styleUrls: ['./dialog-animated-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [DialogModule, PortalModule],
  animations: [dialogOpenAndLeave],
})
export class PalantirDialogAnimatedContainerComponent extends CdkDialogContainer {
  @HostBinding('@slideInOut') public animationState: 'closed' | 'open' | 'void' = 'open';

  public animationStateChanged = new EventEmitter<AnimationEvent>();

  @HostListener('@slideInOut.start', ['$event'])
  public onAnimationStart($event: AnimationEvent) {
    this.animationStateChanged.emit($event);
  }

  @HostListener('@slideInOut.done', ['$event'])
  public onAnimationDone($event: AnimationEvent) {
    this.animationStateChanged.emit($event);
  }

  public startExitAnimation() {
    this.animationState = 'closed';
  }
}
